module.exports = __webpack_public_path__ + "media/images/iconSocialShare__inFrontOfAccent--dark-c9ce48beb66d884e0e48b9628597fc6e.png";